/** Explicit native full-game propositions. No participant/title/slug inference. */
export const US_GAME_PROP_FAMILIES = Object.freeze({
  football_game_overtime: { cls: 'overtime', stat: null, kind: 'binary', label: 'Overtime' },
  football_game_safety: { cls: 'safety', stat: null, kind: 'binary', label: 'Safety scored' },
  football_game_tie: { cls: 'tie', stat: null, kind: 'binary', label: 'Game ends in a tie' },
  football_game_total_two_point_conversions: { cls: 'game-stat', stat: '2pt', kind: 'threshold', label: 'Successful two-point conversions' },
  football_game_total_fourth_down_conversions: { cls: 'game-stat', stat: '4th-down', kind: 'threshold', label: 'Combined fourth-down conversions' },
  football_game_total_defensive_special_teams_touchdowns: { cls: 'game-stat', stat: 'dst-td', kind: 'threshold', label: 'Combined defensive/special-teams TDs' },
  football_game_total_touchdowns: { cls: 'total-touchdowns', stat: null, kind: 'threshold', label: 'Total touchdowns' },
} as const);
export function usGamePropFamily(type: unknown, sport: unknown) {
  return (sport === 'NFL' || sport === 'CFB') && typeof type === 'string'
    && Object.prototype.hasOwnProperty.call(US_GAME_PROP_FAMILIES, type)
    ? US_GAME_PROP_FAMILIES[type as keyof typeof US_GAME_PROP_FAMILIES] : null;
}
/** The published binary families carry 0.5; preserve it as native evidence.
 * Threshold predicates retain the original line, including integer strikes. */
export function validUsGamePropLine(type: unknown, sport: unknown, line: unknown): boolean {
  const family = usGamePropFamily(type, sport);
  return !!family && typeof line === 'string' && /^\d{1,4}(?:\.\d{1,2})?$/.test(line)
    && (family.kind !== 'binary' || Number(line) === 0.5);
}
